import React, { useMemo } from 'react';
import { TimeSeriesLineChart } from '@/components/visuals';
import type { ChartDensity } from '@/components/visuals';
import type { SCurveCumulativePoint } from '@/types/analyticsApi';
import { buildScurveSeries } from './chartUtils';

export interface SCurveActivitiesChartProps {
  planned?: SCurveCumulativePoint[];
  actual?: SCurveCumulativePoint[];
  /** When true and baseline data is provided, show baseline comparison series */
  showBaseline?: boolean;
  /** Baseline planned series (optional; when present and showBaseline, rendered as "Baseline") */
  baselinePlanned?: SCurveCumulativePoint[];
  /** Baseline actual series (optional) */
  baselineActual?: SCurveCumulativePoint[];
  height?: number | string;
  showDataLabels: boolean;
  density?: ChartDensity;
}

export function SCurveActivitiesChart({
  planned,
  actual,
  showBaseline = false,
  baselinePlanned,
  baselineActual,
  height = 260,
  showDataLabels = false,
  density = 'overview',
}: SCurveActivitiesChartProps) {
  const { xAxisData, series } = useMemo(() => {
    const built = buildScurveSeries(planned, actual, 'Planned', 'Actual');
    if (!showBaseline || !baselinePlanned?.length) return built;
    const baselineBuilt = buildScurveSeries(baselinePlanned, [], 'Baseline', '');
    if (!baselineBuilt.series[0]) return built;
    return {
      xAxisData: built.xAxisData,
      series: [...built.series, { name: 'Baseline', data: baselineBuilt.series[0].data }],
    };
  }, [planned, actual, showBaseline, baselinePlanned]);
  return (
    <TimeSeriesLineChart
      xAxisData={xAxisData}
      series={series}
      height={height}
      showDataLabels={showDataLabels}
      density={density}
    />
  );
}
